import { render } from "./ItemByGroupCategory.vue?vue&type=template&id=8547a47e&ts=true"
import script from "./ItemByGroupCategory.vue?vue&type=script&lang=ts"
export * from "./ItemByGroupCategory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__